export default function MySQL_SUBSTRING() {
  return (
    <div>
      <h2>MySQL_SUBSTRING</h2>    </div>
  );
}